import axios from "axios";

import { API_ENDPOINTS } from "../api-urls";


const getAuthToken = () => {
    const token = localStorage.getItem("authToken");
    return token ? `Bearer ${token}` : null;
};

export const verifyRecaptchaToken = async (token) => {
    try {
      console.log("Verifying reCAPTCHA token...", token);
  
      const response = await axios.post(API_ENDPOINTS.recaptcha, { token });
      console.log("reCAPTCHA Verification Response:", response.data);
  
      if (!response.data.success) {
        throw new Error("reCAPTCHA verification failed");
      }
  
      return response.data; // Return full response for flexibility
    } catch (error) {
      console.error(
        "Error verifying reCAPTCHA token:",
        error.response ? error.response.data : error.message
      );
      throw error;
    }
  };

// Function to post a review (only if user is logged in)
export const postReview = async (reviewData) => {
    const token = getAuthToken();
    if (!token) throw new Error("Authentication token missing.");
         
    
    
    try {
        const response = await axios.post(`${API_ENDPOINTS.reviews}/`, reviewData, {
            headers: { Authorization: token },
        });
        return response.data;
    } catch (error) {
        console.error("Error posting review:", error);
        throw error;
    }
};

// Function to update a review by ID (only if user is logged in)
export const updateReviewById = async (reviewId, updatedData) => {
    const token = getAuthToken();
    if (!token) throw new Error("Authentication token missing.");
          
    
    
    try {
        const response = await axios.put(`${API_ENDPOINTS.reviews}/${reviewId}`, updatedData, {
            headers: { Authorization: token },
        });
        return response.data;
    } catch (error) {
        console.error("Error updating review:", error);
        throw error;
    }
};

// Function to get all reviews of a specific product
export const getReviewsByProductId = async (productId) => {
  try {
      console.log("Fetching reviews from API...");
      const response = await axios.get(`${API_ENDPOINTS.reviews}/getAllReviewsOfAProduct/${productId}`);
      
      console.log("Full API response:", response);
      console.log("Response data:", response.data);

      return response.data;
  } catch (error) {
      console.error("Error fetching product reviews:", error);
      throw error;
  }
};


// Function to get all reviews of a user
export const getAllReviewsOfUser = async () => {
    const token = getAuthToken();
    if (!token) throw new Error("Authentication token missing.");
         
    
    
    try {
        const response = await axios.get(`${API_ENDPOINTS.reviews}/`, {
            headers: { Authorization: token },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching user reviews:", error);
        throw error;
    }
};
